// extracted by mini-css-extract-plugin
export var slider = "slider-module--slider--c1030";